import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import './Loader3D.css';

const LOGO = '/images/Tunify Original logo tab.png';

// Branded loading overlay for 3D canvases — the logo breathing inside a
// spinning ring, with bouncing dots. Covers the black canvas flash while the
// WebGL context boots and the scene compiles/paints, then fades out. Keep it
// mounted and toggle `visible` so the fade-out can play (unmounting would pop).
export default function Loader3D({ visible = true, label }) {
  return (
    <div className={`ld3-overlay${visible ? '' : ' ld3-overlay--hidden'}`} aria-hidden={!visible}>
      {/* Spinning ring removed per request — just the logo, label and dots. */}
      <div className="ld3-badge">
        <img src={LOGO} alt="Tunify" className="ld3-logo" draggable={false} />
      </div>
      {label && <span className="ld3-label">{label}</span>}
      <span className="ld3-dots"><i /><i /><i /></span>
    </div>
  );
}

// Rendered INSIDE a <Canvas>. Once the scene has actually painted a few frames
// (so the black canvas is gone), it calls onReady exactly once — the parent
// uses that to fade the overlay out. If the scene is suspended (loading an
// HDR/GLB) this simply doesn't tick until it resolves, which is exactly when
// we want the overlay to lift.
export function SceneReadySignal({ onReady, frames = 3 }) {
  const count = useRef(0);
  const done  = useRef(false);
  useFrame(() => {
    if (done.current) return;
    count.current += 1;
    if (count.current >= frames) {
      done.current = true;
      onReady && onReady();
    }
  });
  return null;
}
